import './mySkills.css';
import React from 'react'

const mySkills = () =>{
    return (
        <div className='mySkills'>
            my SKills 
        </div>
    )
}

export default mySkills;